import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Daincaihou"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.2 9.80011V12.2001C9.2 13.1942 8.39413 14.0001 7.4 14.0001L5 8.60011V2.00011H11.972C12.5704 1.99334 13.0823 2.42848 13.172 3.02011L14 8.42011C14.0528 8.76821 13.9501 9.12195 13.7191 9.38761C13.4881 9.65328 13.1521 9.80411 12.8 9.80011H9.2Z",
  stroke: "#FFA755",
  "stroke-width": "1.33333",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M5 8.66667H3.398C2.69511 8.67911 2.09423 8.09687 2 7.40024V3.20024C2.09423 2.50357 2.69511 1.98781 3.398 2.00024H5V8.66667Z",
  stroke: "#FFA755",
  "stroke-width": "1.33333",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var daincaihou = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { daincaihou as default };
